import React, { useEffect, useState } from 'react';
import EntrataInstruction from './EntrataInstruction';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';
import { INTEGRATION_ROUTES } from '../../../constants/constants';
import { connectToEntrata, getFormAndTaxYearList, getLoadImportData, getFormSetting } from './EntrataSaga';
import { componentKey as entratacomponentkey } from './EntrataSlice';
import Breadcrumbs from '../../../../components/breadcrumbs/Breadcrumbs';
import Button from '../../../../components/button/Button';
import { BUTTON_TYPE } from '../../../../components/button/constants';
import Loadable from '../../../../components/loadable/Loadable';
import RichGrid from '../../../../components/richgrid/RichGrid';
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown';
import { INTEGRATION_WRAPPER_LOADING_STATES_MESSAGE_MAP, INTEGRATION_WRAPPER_LOADING_STATES, SOURCE_CONSTANTS, INTEGRATION_CONSTANTS, FORM_IDS } from '../constants';
import { VEC_ICON_NAME } from '../../../../components/icons/constants';
import styles from './Entrata.styles';
import { useDispatch, useSelector } from 'react-redux';
import ImportDataGridView from '../../../components/importdatagridview/ImportDataGridView';


export default function Entrata(){
    useGarbageCollector(entratacomponentkey);
    const [taxYearOptions, setTaxYearOptions] = useState([]);
    const [formOptions, setFormOptions] = useState([]);
    const [formattedTenantList, setFormattedTenantList] = useState([]);
    const [selectedFormMap, setSelectedFormMap] = useState({});
    const [taxYearMap, setTaxYearMap] = useState({});
    const [selectedPayerTypeMap, setSelectedPayerTypeMap] = useState({});
    const [selectedForm, setSelectedForm] = useState({});
    const [selectedTaxYear, setSelectedTaxYear] = useState({});
    const dispatch = useDispatch();
    const {loadingState, tenantList, formAndTaxYearList, importData, isImportDataGridViewLoaded, formSettings} = useSelector(state => state[entratacomponentkey]);

    const breadcrumbsItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
        { text: 'Entrata' }
    ];

    useEffect(() => {
        dispatch(connectToEntrata());
        dispatch(getFormAndTaxYearList());
    }, []);

    useEffect(() => {
        if (formAndTaxYearList) {
            setTaxYearOptions(formAndTaxYearList.TaxYear);
            setFormOptions(formAndTaxYearList.FormType);
        }
    }, [formAndTaxYearList]);

    useEffect(() => {
        const fetchFormattedTenantData = () => {
            if (tenantList && tenantList.length > 0) {
                const formattedList = tenantList.map(tenant => ({
                    TenantName: tenant.TenantName,
                    TenantId: tenant.TenantId
                }));
                setFormattedTenantList(formattedList);
            }
            else {
                setFormattedTenantList([]);
            }
        };

        fetchFormattedTenantData();
    }, [tenantList]);

    const handleDataLoad = (tenantId) => {
        if (tenantId && taxYearMap[tenantId] && selectedFormMap[tenantId] && selectedPayerTypeMap[tenantId]) {
            dispatch(getLoadImportData({
                integrationImportRequestDto: {
                    TaxYear: taxYearMap[tenantId],
                    FormName : selectedFormMap[tenantId],
                    BusinessId : tenantId, 
                    PayerId : selectedPayerTypeMap[tenantId],
                    Source : SOURCE_CONSTANTS.ENTRATA_SOURCE
                }
            }));
            setSelectedForm(selectedFormMap[tenantId]);
            setSelectedTaxYear(taxYearMap[tenantId]);
        } else {
            dispatch(addNotifications({
                heading: "Required fields missing",
                message: "Please choose tax year and form type to proceed"
            }));
        }
    };

    useEffect(() => {
        if (importData) {
            dispatch(getFormSetting({ formId: selectedForm, year: selectedTaxYear }));
        }
    }, [importData]);
    

    const gridColumns = [
        {
            header: 'User Name',
            renderLogic: (row) => (
                <div style={styles.gridRecordsMargin}>
                    <span>{row?.TenantName}</span>
                </div>
            )
        },
        {
            header: 'Tax Year',
            renderLogic: (row) => (
                <div style={styles.gridRecordsMargin}>
                    <SelectDropdown
                        label=""
                        placeHolder="Select taxYear"
                        name="taxYear"
                        value={{ label: taxYearMap[row?.TenantId] || '', value: taxYearMap[row?.TenantId] || '' }}
                        onSelectCb={(name, selectedOption) => setTaxYearMap(prevState => ({
                            ...prevState,
                            [row.TenantId]: selectedOption.value
                        }))}
                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                        options={taxYearOptions}
                        dropdownMenuStyle={styles.dropdownWidth}
                        dropdownContainerStyles={styles.dropdownWidth}
                    />
                </div>
            )
        },
        {
            header: 'Form Type',
            renderLogic: (row) => (
                <div style={styles.gridRecordsMargin}>
                    <SelectDropdown
                        label=""
                        placeHolder="Select Form"
                        name="selectedForm"
                        value={{ label: selectedFormMap[row?.TenantId] || '', value: selectedFormMap[row?.TenantId] || '' }}
                        onSelectCb={(name, selectedOption) => setSelectedFormMap(prevState => ({
                            ...prevState,
                            [row.TenantId]: selectedOption.value
                        }))}
                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                        options={formOptions}
                        dropdownMenuStyle={styles.dropdownWidth}
                        dropdownContainerStyles={styles.dropdownWidth}
                    />
                </div>
            )
        },
        {
            header: 'Payer Type',
            renderLogic: (row) => (
                <div style={styles.gridRecordsMargin}>
                    <SelectDropdown
                        label=""
                        placeHolder="Select Payer Type"
                        name="selectedPayerType"
                        value={{ label: selectedPayerTypeMap[row?.TenantId] || '', value: selectedPayerTypeMap[row?.TenantId] || '' }}
                        onSelectCb={(name, selectedOption) => setSelectedPayerTypeMap(prevState => ({
                            ...prevState,
                            [row.TenantId]: selectedOption.value
                        }))}
                        suffixProps={{ icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET }}
                        options={[
                            { label: 'Owner', value: 'Owner' },
                            { label: 'Property', value: 'Property' }
                        ]}
                        dropdownMenuStyle={styles.dropdownWidth}
                        dropdownContainerStyles={styles.dropdownWidth}
                    />
                </div>
            )
        },
        {
            header: 'Actions',
            renderLogic: (row) => (
                <div style={styles.gridRecordsMargin}>
                    <Button
                        type={BUTTON_TYPE.PRIMARY}
                        title="DataLoad"
                        onClickCb={() => handleDataLoad(row?.TenantId)}
                    >
                        Load Data
                    </Button>
                </div>
            )
        }
    ];

    return (
        <>
            <Breadcrumbs items={breadcrumbsItems} />
            {(formSettings && selectedTaxYear && selectedForm && isImportDataGridViewLoaded) ? (
                <ImportDataGridView
                    isStateFilingApplicable={false}
                    filingForCorrected={false}
                    formSettings={formSettings}
                    formName={selectedForm}
                    formId={
                        (() => {
                            switch (selectedForm) {
                                case INTEGRATION_CONSTANTS.NEC_FORM:
                                    return FORM_IDS.$1099NEC;
                                case INTEGRATION_CONSTANTS.MISC_FORM:
                                    return FORM_IDS.$1099MISC;
                                default:
                                    return null;
                            }
                        })()
                    }
                    taxYear={selectedTaxYear}
                />
            ) : (
                <div style={styles.container}>
                    <div style={styles.marginBottomStyle}>
                        <EntrataInstruction />
                    </div>
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING}
                        messageMap={INTEGRATION_WRAPPER_LOADING_STATES_MESSAGE_MAP}
                        isNewLoadable={true}
                    >
                        {formattedTenantList && gridColumns && (
                            <RichGrid
                                columns={gridColumns}
                                data={formattedTenantList}
                            />
                        )}
                    </Loadable>
                </div>
            )}
        </>
    );
}